<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western6" id="calibre_toc_6">Chapter 5</h1>
<p class="western7">Baj told us he saw the man walking down the
street before he even got close enough to knock on the front door.
Apparently Warren Hightower has a swagger that is hard to miss once
you’ve seen it. Then again, any well-dressed stranger is worth
noting if you happen to be looking out your window at just the
right time.</p>
<p class="western7">After getting his breathing under control, he
called down to Jayashri and quickly detailed his plan to properly
greet the Devil that was about to knock on the front door. She
agreed, started the water boiling for tea, and adjusted her sari.
For himself, Baj combed his hair, splashed some water on his face,
and composed himself a tiny bit more.</p>
<p class="western7">There was a knock on the door, and he heard
his wife attend to greeting their guest.</p>
<p class="western7">“Mister Hightower. Bajali has been expecting
you for some time. Do come in,” she said with a delightful lilt in
her voice. “May I serve you tea?”</p>
<p class="western7">He heard them moving around the living room
and how she gently suggested where their guest should sit. It was
the chair with the clearest line of sight from the kitchen, and all
Baj could think was that he had married an utterly irreplaceable
woman.</p>
<p class="western7">“Mrs. Sharma, I would very much enjoy tea.
Thank you for your hospitality.”</p>
<p class="western7">“My pleasure. Please, sit. This is a very
comfortable chair for our guests who have a more Western sense of
how a seat should be. Bajali will be with you shortly. I am sure
you know how difficult it is to pull him away from a project.”</p>
<p class="western7">Hightower laughed gently. Bajali was well
known for how deeply he could sink into any project that caught his
attention, and he remembered the ribbing he had received from
everyone.</p>
<p class="western7">“Yes, Bajali could ignore almost anything in
favor of his work,” the guest said, “except for you. Now that I’ve
met you, I can understand why.”</p>
<p class="western7">“You are too kind,” she replied, “I will
bring you tea. Do you take sugar and cream?”</p>
<p class="western7">“Yes. Thank you again.”</p>
<p class="western7">Jayashri floated off into the kitchen,
leaving Hightower alone in the living room, relaxing in an
astoundingly comfortable easy chair. Bajali called down to his wife
in the kitchen, speaking in Hindi. Then he walked downstairs and
crossed into the room.</p>
<p class="western7">Hightower started to stand.</p>
<p class="western7">“No, Mister Hightower, there’s no need to be
so formal. Be at ease.” Bajali sat in the chair opposite him,
separated by a roughly hewn wood coffee table.</p>
<p class="western7">‘Bajali, I can’t tell you how nice it is to
be greeted with something other than an armed response,” he smiled
that winning smile, made unfortunate only by how far his gums had
receded, “and that dovetails so neatly into what I came to talk to
you about.”</p>
<p class="western7">Baj related the bill of goods Hightower
attempted to sell him on. It sounded wonderful, if you were a
zombie: a peaceful meeting of the minds where X percent of the
population would be kept as cattle for the undead to feed upon, and
the rest of mankind was left alone to pursue their lives. Better
yet! Given time, the two societies might integrate again and build
a new future for the entire planet!</p>
<p class="western7">I think we all rolled our eyes when we heard
that. Shawn looked more like he wanted to hand back his dinner at a
supersonic speed, but he managed to control the reflex with the
sheer force of his willpower.</p>
<p class="western7">Our friend had more to share, and we
swallowed our disgust long enough to listen.</p>
<p class="western7">“I must tell you, Baj, I was uncertain of the
welcome I would receive were I to visit you. I am moved, deeply
moved, by your hospitality and warmth.”</p>
<p class="western7">“Well, you know, Mister Hightower, greeting
guests in a civilized manner has been practiced and refined for
thousands of years in India.” Baj reported this segment of the
conversation with an insane, obsequious smile on his face, and I
can only imagine what it had looked like during the original
chat.</p>
<p class="western7">His guest complimented him on his superb
hospitality for a final time, and urged him to pass the regards
along to Mister and Mrs. Sharma, Senior, if ever the opportunity
presented itself.</p>
<p class="western7">Bajali laughed heartily and replied, “It
isn’t that different in India, you know. I will tell them you spoke
well of the results of their hard labor. I suspect they will be
pleased.”</p>
<p class="western7">At this point in the visitation, Jayashri
brought in the tea, poured them both a cup, inquired about lumps of
sugar and milk before deftly stirring each cup, and retreated
softly into the kitchen. She added, to us, that she found the
nearest firearm as soon as the tea service was safely settled on
the countertop.</p>
<p class="western7">“She is... so graceful.” Hightower sipped the
tea, still smiling.</p>
<p class="western7">“She never ceases to amaze me. So, what
brings you to my home? It has been quite a while since we last
conversed. I believe you were on a flight to Baghdad at the
time.”</p>
<p class="western7">“Yes, I’d called you to get an update on the
A-344 program. That’s why I’m here now, as a matter of fact. I
would like you to continue your work on that project for me.”</p>
<p class="western7">“I hardly have the facilities for such a
thing, with the world changing as it has,” Bajali replied. As an
aside to us, he explained that the mere mention of the A-344
program was enough to reveal how our neighbor planned to bring
about his perfect world of coexistence.</p>
<p class="western7">Hightower nodded at him, “I know. I still
have all the equipment, materials, and data in a new location. All
you have to do is come on board and we can finish A-344.”</p>
<p class="western7">“May I ask why you would be interested in
such a thing,” Bajali waved his hand idly in the air, “after you’ve
gone through the change in your life?” The question was
superfluous, really, because he knew full well what the answer
would be. He simply wanted to soothe his soul over the truth,
before he made the decision to try and kill his guest.</p>
<p class="western7">“Let me tell you why,” and Hightower
explained what was known about the virus, how it operates in the
human host, and his plan to make a herd of human cattle for the
zombie population.</p>
<p class="western7">“Ah.” Bajali did not let his disgust show
because he had predicted his work could be used in such a manner:
selectively targeting and infecting a swath of the population. “I
can see that you’ve given this the thought it deserves. Indeed, I
can see how you have come to the conclusion this would bring
stability to the situation, if not actual peace.”</p>
<p class="western7">“I knew you would understand, Bajali. The big
picture was never lost on you.”</p>
<p class="western7">They sat quietly for some minutes, sipping
tea.</p>
<p class="western7">Baj told us he had truly expected some sort
of threat to be delivered during those tea-laden moments. He was
aware that in certain circles there was an unspoken rule that you
never threaten the family of a man from whom you need something. A
family man would gladly force you to kill him, thereby saving his
loved ones, rather than allow them to be harmed. Any threats had to
be intensely personal and backed up by action, until the subject
broke. Then you could threaten the family with impunity.</p>
<p class="western7">Surprisingly enough, no threat appeared. With
no threat, there was less certainty that action was necessary, or
so Bajali felt. Instead, he tried a delaying tactic in hopes it
would give us more time to figure out a course of action.</p>
<p class="western7">“Warren? May I call you Warren?”</p>
<p class="western7">“Of course, Bajali.”</p>
<p class="western7">“Warren, I would like to have a day or two to
think this over. We are, after all, talking about altering the
world as we have known it in a way that makes the fear of climate
change look like small potatoes.”</p>
<p class="western7">“Absolutely! I would not have it any other
way. If two days will help you work with me, then I will gladly
spend them.”</p>
<p class="western7">“Thank you so much, Warren. I will discuss
this with Jayashri, if you do not mind. She is, in so many ways, my
better half.”</p>
<p class="western7">“Please do. I tell you what, I’ll drop by
again in two days and we can review the details. Will that work for
you?”</p>
<p class="western7">“I think that would be marvelous. May I pour
you more tea?”</p>
<p class="western7">“I would, but I do have a schedule to keep,
and I walked here. It will take a bit of time to get back to our
staging area, and I’ll have to refresh the virus when I
arrive.”</p>
<p class="western7">“Ah. In that case, don’t let me keep
you.”</p>
<p class="western7">Bajali escorted his former employer to the
front door. They shook hands with smiles and promises to speak
again in two days. Hightower left and strolled down the street with
a swing in his step.</p>
<p class="western7">Bajali closed the door, leaned up against it,
and took a deep breath. There was a metallic click behind him, and
he turned to see his wife standing in the doorway between rooms.
She had just released the hammer on the .44 Magnum she was holding
in her delicate hands.</p>
<p class="western7">“My love, did we not decide the 9mm fit your
hand better than the .44?”</p>
<p class="western7">“Yes, my treasure, but we don’t have soft,
jacketed hollow points for the 9. I was also concerned about
needing more than one round to destroy his skull with the smaller
pistol.”</p>
<p class="western7">At that point, he walked over to her,
embraced her, kissed her on the forehead and said, “I am never
disappointed when I trust your judgment. You are the finest part of
my life.”</p>
<h1 class="western8">
</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_f099aff482e799492a35054ee1867e1f_WrMliK.ch.fixed.fc.tidied.stylehacked.xfixed_split_008.vue?c78c38ac